import { useNavigate } from 'react-router';
import { AvailableTrafficCard } from '../components/Dashboard/AvailableTrafficCard';
import ProxyPools from '../components/Dashboard/ProxyPools';
import Flex from '../components/ui/Flex';
import { useSession } from '../context/session/useSession';
import { useEffect } from 'react';
import SignUpSurveyDialog from '../components/SignUpSurveyDialog';
import ProxyUsageChart from '../components/Dashboard/ProxyUsageChart';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import Page from '../components/ui/Page';

function Dashboard() {
  const navigate = useNavigate();
  const { session } = useSession();

  const isChartEnabled = useFeatureFlagEnabled('dashboard-proxy-usage-chart');
  useEffect(() => {
    if (!session) navigate('/account/signin');
  }, [navigate, session]);

  return (
    <Page.Container>
      {session && <SignUpSurveyDialog />}
      <Page.Heading>
        <Page.Title>Dashboard</Page.Title>
        <Page.Description>
          Manage your proxy pools and traffic
        </Page.Description>
      </Page.Heading>
      <Page.Body>
        <Flex.Row className="gap-5 w-full">
          <AvailableTrafficCard />
          <div className="hidden md:block w-full">
            {isChartEnabled && <ProxyUsageChart />}
          </div>
        </Flex.Row>
        <ProxyPools />
      </Page.Body>
    </Page.Container>
  );
}

export default Dashboard;
